import { buildAuditOutcomeFields, type TemplateOperationCompleteEvent } from 'adflow';

import { sanitizeLogValue } from '../webmcp/sanitize';
import { TRPCClient } from '../utils/apiClient';

const OBJECT_ID_PATTERN = /^[0-9a-fA-F]{24}$/;

function asSanitizedSummary(value: unknown): Record<string, unknown> | null {
  const sanitized = sanitizeLogValue(value);
  if (!sanitized || typeof sanitized !== 'object' || Array.isArray(sanitized)) {
    return null;
  }
  return sanitized as Record<string, unknown>;
}

export async function postTemplateOperationAudit(
  templateId: string,
  event: TemplateOperationCompleteEvent,
): Promise<void> {
  if (!OBJECT_ID_PATTERN.test(templateId)) {
    return;
  }

  const fields = buildAuditOutcomeFields(event.result);

  const payload = {
    invocationId: event.invocationId,
    templateId,
    source: event.source,
    toolName: event.toolName ?? null,
    operation: event.operation,
    startedAt: new Date(event.startedAt),
    completedAt: new Date(event.completedAt),
    durationMs: event.durationMs,
    workingRevision: fields.workingRevision ?? null,
    persistedRevision: null,
    outcome: fields.outcome,
    errorCode: fields.errorCode ?? null,
    inputSummary: asSanitizedSummary(event.inputArgs),
    outputSummary: fields.outputSummary ?? null,
  };

  type IngestOperationAuditClient = {
    ingestOperationAudit: {
      mutate: (
        input: typeof payload,
      ) => Promise<{ status: 'acknowledged' | 'pending'; invocationId: string }>;
    };
  };

  await (
    TRPCClient.client.adTemplate as unknown as IngestOperationAuditClient
  ).ingestOperationAudit.mutate(payload);
}
